const map = {
	"./ar.json": 81818,
	"./de.json": 81730,
	"./el.json": 80472,
	"./en.json": 51754,
	"./es.json": 81273,
	"./fa.json": 22116,
	"./fr.json": 1665,
	"./hi.json": 14234,
	"./id.json": 48508,
	"./it.json": 25420,
	"./lt.json": 48421,
	"./ms.json": 62209,
	"./nl.json": 13355,
	"./pl.json": 93673,
	"./pt.json": 37489,
	"./ru.json": 34172,
	"./sv.json": 63280,
	"./th.json": 72929,
	"./tl.json": 82805,
	"./tr.json": 75775,
	"./uk.json": 19473,
	"./vi.json": 65692,
	"./zh_CN.json": 64301
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51020;